// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import isApiError from "@insite/client-framework/Common/isApiError";
import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface AssignUserParameter {
    id: string;
    assign: boolean;
}

const AssignUserUrl = "api/ces/masterAccounts/assign";

export async function assignUserService(parameter: AssignUserParameter): Promise<ServiceResult<{}>> {
    try {
        const accounts = await post<AssignUserParameter>(
            `${AssignUserUrl}?id=${parameter.id}&assign=${parameter.assign}`,
        );
        return {
            result: accounts,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        return error;
    }
}
